export default function(_) {
  for (var s={}, i=0, n=_.length; i<n; ++i) s[_[i]] = 1;
  return s;
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-util/src/toSet.js
// module id = 1546
// module chunks = 0